module.exports = __webpack_public_path__ + "img/slider5.7c14451d.jpg";